window.ExternalDeal ?= {}

ExternalDeal.init = ({externalDeal}, done) ->
  return done() unless externalDeal

  $ ->
    $externalBuyButton = $('.external-buy')
    $externalBuyButton.click (e) ->
      e.preventDefault()
      window.open $(this).attr('href')
      setTimeout GIG.Modal.close, 3000

    done()


module.exports = ExternalDeal
